import * as Yup from 'yup';
import { isEligibleForResolutionAttachment } from '../../functions/governmentActEligibility';
import {
    shouldShowCommitteeObject,
    shouldShowFactor,
} from '../../functions/factorObjectVisibility';

export const resolutionSchema = Yup.object().shape({
    number: Yup.string('Это не строка'),
    responsibleFullName: Yup.string('Это не строка').required('Должностное лицо санитарно-эпидемиологической службы ( Ф.И.О.) должно быть заполнено'),
    acts: Yup.array()
        .min(1, 'Список актов обязателен к заполнению')
        .test(
            'resolution-attachments',
            'К постановлению можно прикрепить акт госзаказа или направление',
            (acts) => !acts?.length || acts.every(isEligibleForResolutionAttachment),
        ),
    indicators: Yup.array()
        .min(1, 'Показатели обязательны к заполнению'),
    factorId: Yup.mixed().nullable().test(
        'factor-required',
        'Фактор обязателен для заполнения',
        function (value) {
            if (!shouldShowFactor(this.parent.purpose)) return true;
            return value != null && value !== '';
        },
    ),
    objectId: Yup.mixed().nullable().test(
        'object-required',
        'Объект обязателен для заполнения',
        function (value) {
            if (!shouldShowCommitteeObject(this.parent.purpose, this.parent.factor)) return true;
            return value != null && value !== '';
        },
    ),
});
